import ChapterView from './chapter/ChapterView'
import LessonView from './lesson/LessonView'
import { QuizView } from '@brainstud/react-tbl/features/quiz'

export const Views = {
  Chapter: ChapterView,
  Lesson: LessonView,
  Quiz: QuizView,
}

export { default as IndexView } from './IndexView'
